import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type {
  NetworkInterceptorParameterizationModel,
  NetworkInterceptorCapturedRequest,
} from '@/utils/networkInterceptorParameterization';

interface ParameterizationState {
  isOpen: boolean;
  model: NetworkInterceptorParameterizationModel | null;
  originalRequests: NetworkInterceptorCapturedRequest[];
}

const initialState: ParameterizationState = {
  isOpen: false,
  model: null,
  originalRequests: [],
};

const parameterizationSlice = createSlice({
  name: 'parameterization',
  initialState,
  reducers: {
    setParameterizationData(
      state,
      action: PayloadAction<{
        model: NetworkInterceptorParameterizationModel;
        originalRequests: NetworkInterceptorCapturedRequest[];
      }>
    ) {
      state.model = action.payload.model;
      state.originalRequests = action.payload.originalRequests;
      state.isOpen = true;
    },
    closeParameterization(state) {
      state.isOpen = false;
    },
    clearParameterization() {
      return initialState;
    },
  },
});

export const {
  setParameterizationData,
  closeParameterization,
  clearParameterization,
} = parameterizationSlice.actions;

export default parameterizationSlice.reducer;
